var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEbook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "white",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.7188 64.6118V26.6956C74.7188 23.6541 72.2527 21.188 69.2112 21.188H38.2001C35.4669 21.188 33.2062 23.1609 32.7747 25.7709H60.5187C65.8208 25.7709 70.1365 30.0866 70.1365 35.3887V70.0378C72.7465 69.6062 74.7194 67.3456 74.7194 64.6124L74.7188 64.6118Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 35.3882V73.3044C24 76.3459 26.4661 78.812 29.5076 78.812H60.5187C63.5603 78.812 66.0264 76.3459 66.0264 73.3044V35.3882C66.0264 32.3467 63.5603 29.8806 60.5187 29.8806H29.5076C26.4661 29.8806 24 32.3467 24 35.3882ZM34.6661 41.944H45.0033C46.1542 41.944 47.0584 42.8687 47.0584 43.999C47.0584 45.1499 46.1542 46.0541 45.0033 46.0541H34.6661C33.5357 46.0541 32.611 45.1499 32.611 43.999C32.611 42.8687 33.5357 41.944 34.6661 41.944ZM34.6661 52.3016H55.361C56.4913 52.3016 57.4161 53.2058 57.4161 54.3567C57.4161 55.487 56.4913 56.4118 55.361 56.4118H34.6661C33.5357 56.4118 32.611 55.487 32.611 54.3567C32.611 53.2058 33.5357 52.3016 34.6661 52.3016ZM34.6661 62.6389H55.361C56.4913 62.6389 57.4161 63.5636 57.4161 64.6939C57.4161 65.8243 56.4913 66.749 55.361 66.749H34.6661C33.5357 66.749 32.611 65.8243 32.611 64.6939C32.611 63.5636 33.5357 62.6389 34.6661 62.6389Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEbook);
export default __webpack_public_path__ + "static/media/icon-ebook.6f51bafd800788160e4c7a5599920881.svg";
export { ForwardRef as ReactComponent };